//#region imports
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, HashLocationStrategy, LocationStrategy, DatePipe } from '@angular/common';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DetailsModule } from './module/details/details.module';
import { GuaranteeModule } from './module/guarantee/guarantee.module';
import { SignatureModule } from './module/signature/signature.module';
import { RecapitulatoryModule } from './module/recapitulatory/recapitulatory.module';
import { CharacteristicsModule } from './module/characteristics/characteristics.module';
import { SharedModule } from './shared/shared.module';

import { AppComponent } from './app.component';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';

import { environment } from 'src/environments/environment';
import { Apipath } from 'src/assets/Apipaths/apiUrl';
import { LandingComponent } from './landing/landing.component';
import { AngularIbanModule } from 'angular-iban';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button'; 
import { CustomSpinnerComponent } from './shared/components/custom-spinner/custom-spinner.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { PixelModule } from 'ngx-pixel';
import 'simplebar';
//#endregion

@NgModule({
  declarations: [
    AppComponent, ProgressBarComponent, LandingComponent
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy }
  ],
  imports: [
    SharedModule, CharacteristicsModule, DetailsModule,
    GuaranteeModule, RecapitulatoryModule, SignatureModule,
    BrowserModule, AppRoutingModule, BsDropdownModule.forRoot(),
    BrowserAnimationsModule, FormsModule, ReactiveFormsModule,
    TabsModule.forRoot(), CarouselModule.forRoot(), HttpClientModule, AngularIbanModule,
    PixelModule.forRoot({ enabled: true, pixelId: '362173264838630' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient]
      },
      isolate: false
    }),
    NgCircleProgressModule.forRoot({
      backgroundColor: 'transparent',
      radius: 8,
      maxPercent: 100,
      outerStrokeWidth: 20,
      outerStrokeColor: '#ee8007',
      outerStrokeLinecap: 'butt',
      showTitle: false,
      showSubtitle: false,
      showUnits: false,
      showInnerStroke: false,
      startFromZero: false,
      animation: true,
      animationDuration: 500,
      backgroundPadding: 0
    }),
    NgHttpLoaderModule.forRoot(), CommonModule, DeviceDetectorModule.forRoot(), AccordionModule.forRoot(),
    BackButtonDisableModule.forRoot()
  ],
  bootstrap: [AppComponent],
  entryComponents: [CustomSpinnerComponent]
})
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  const getlangurl = environment.apiURL + Apipath.Languagepath;
  return new TranslateHttpLoader(http, getlangurl, '');
}
